var _g, _g2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGetALabel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 147,
    viewBox: "0 0 157 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16,
    filter: "url(#filter0_f_7321_20010)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.75,
    cy: 73.3304,
    rx: 48.25,
    ry: 43.3304,
    fill: "#9A45F4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_n_7321_20010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.7856 110.481C76.6607 110.937 77.0982 111.165 77.7052 111.283C78.178 111.375 78.8598 111.375 79.3326 111.283C79.9396 111.165 80.3772 110.937 81.2523 110.481C89.343 106.265 112.61 92.4896 112.61 73.4791V57.3608C112.61 53.9537 112.61 52.2502 112.053 50.7859C111.561 49.4923 110.761 48.338 109.722 47.4229C108.547 46.387 106.952 45.7888 103.762 44.5925L80.913 36.0242C80.027 35.692 79.5841 35.5259 79.1284 35.4601C78.7242 35.4017 78.3137 35.4017 77.9095 35.4601C77.4538 35.5259 77.0108 35.692 76.1249 36.0242L53.2761 44.5925C50.086 45.7888 48.491 46.387 47.3155 47.4229C46.2771 48.338 45.4772 49.4923 44.985 50.7859C44.4277 52.2502 44.4277 53.9537 44.4277 57.3608V73.4791C44.4277 92.4896 67.6948 106.265 75.7856 110.481Z",
    fill: "#0D0034",
    fillOpacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7856 110.481C76.6607 110.937 77.0982 111.165 77.7052 111.283C78.178 111.375 78.8598 111.375 79.3326 111.283C79.9396 111.165 80.3772 110.937 81.2523 110.481C89.343 106.265 112.61 92.4896 112.61 73.4791V57.3608C112.61 53.9537 112.61 52.2502 112.053 50.7859C111.561 49.4923 110.761 48.338 109.722 47.4229C108.547 46.387 106.952 45.7888 103.762 44.5925L80.913 36.0242C80.027 35.692 79.5841 35.5259 79.1284 35.4601C78.7242 35.4017 78.3137 35.4017 77.9095 35.4601C77.4538 35.5259 77.0108 35.692 76.1249 36.0242L53.2761 44.5925C50.086 45.7888 48.491 46.387 47.3155 47.4229C46.2771 48.338 45.4772 49.4923 44.985 50.7859C44.4277 52.2502 44.4277 53.9537 44.4277 57.3608V73.4791C44.4277 92.4896 67.6948 106.265 75.7856 110.481Z",
    stroke: "url(#paint0_linear_7321_20010)",
    strokeWidth: 0.65281,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.3184 73.3419L73.8412 81.8647L90.8867 64.8191",
    stroke: "url(#paint1_linear_7321_20010)",
    strokeWidth: 2.82884,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7321_20010",
    x: 0.982355,
    y: 0.482355,
    width: 155.535,
    height: 145.696,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.7588,
    result: "effect1_foregroundBlur_7321_20010"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_n_7321_20010",
    x: 44.1016,
    y: 35.0898,
    width: 68.834,
    height: 76.5883,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "noise",
    type: "luminanceToAlpha",
    result: "alphaNoise"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    in: "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    type: "discrete",
    tableValues: "1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
  })), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "shape",
    in: "coloredNoise1",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgba(255, 255, 255, 0.48)",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "noise1Clipped",
    in: "color1Flood",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_noise_7321_20010"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shape"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "color1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7321_20010",
    x1: 78.5189,
    y1: 35.4163,
    x2: 78.5189,
    y2: 111.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEFE",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7321_20010",
    x1: 90.9995,
    y1: 73,
    x2: 67.9995,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0596A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.197115,
    stopColor: "#3971F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.423077,
    stopColor: "#9A45F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615385,
    stopColor: "#FC7D06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807692,
    stopColor: "#F7E144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4626"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetALabel);
export default __webpack_public_path__ + "static/media/getALabel.0d5ee87d60e35b5f74a362ceeca495c4.svg";
export { ForwardRef as ReactComponent };